export function toCentavos(valor: number | null | undefined): number {
  if (valor == null || isNaN(valor)) return 0;
  return Math.round(valor * 100);
}

export function fromCentavos(valor: number | null | undefined): number {
  if (valor == null) return 0;
  return valor / 100;
}
